export var CowStatusMessage;
(function (CowStatusMessage) {
    CowStatusMessage["Open"] = "Order Placed";
    CowStatusMessage["Fulfilled"] = "Order Fulfilled";
    CowStatusMessage["Cancelled"] = "Order Cancelled";
    CowStatusMessage["Expired"] = "Order Expired";
})(CowStatusMessage || (CowStatusMessage = {}));
